import { ApiError } from '@/lib/api-client'

/**
 * Regra de repetição das consultas (React Query): uma nova tentativa em caso de
 * erro de rede, NUNCA em 429. O 429 é o servidor pedindo para esperar (limite de
 * leitura em lote, #1445); repetir na hora gasta mais uma página da cota e não
 * muda a resposta.
 */
export function repetirConsulta(tentativas: number, erro: unknown): boolean {
  if (erro instanceof ApiError && erro.status === 429) return false
  return tentativas < 1
}
